<template lang="pug">
mixin usaInfo(cls)
  .subBasketHolder.p-4.mb-4.usaInfo(class=cls, v-if="countryPriceAttention.show && currentCountryCode === 'US'", v-show="opened && !loading", style="background: #FFF2F3; border: none")
    .flex.justify-between.basket-row
      .icon.mr-1
        ExclamationAlertIcon(color="#FA5F55", topPosition="3")
      .txt.text-sm.text-accentColor(v-html="countryPriceAttention.text")
      .close.ml-1(class="lg1024:hidden", @click="opened = false").
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.46967 12.4697C2.17678 12.7626 2.17678 13.2374 2.46967 13.5303C2.76256 13.8232 3.23744 13.8232 3.53033 13.5303L7.99999 9.06067L12.4697 13.5304C12.7626 13.8232 13.2374 13.8232 13.5303 13.5304C13.8232 13.2375 13.8232 12.7626 13.5303 12.4697L9.06065 8.00001L13.5303 3.53033C13.8232 3.23744 13.8232 2.76256 13.5303 2.46967C13.2374 2.17678 12.7626 2.17678 12.4697 2.46967L7.99999 6.93935L3.53033 2.46969C3.23744 2.1768 2.76256 2.1768 2.46967 2.46969C2.17678 2.76258 2.17678 3.23746 2.46967 3.53035L6.93933 8.00001L2.46967 12.4697Z" fill="#FA5F55"/>
        </svg>
mixin ilInfo(cls)
  .subBasketHolder.p-4.mt-4.ilInfo(class=cls, v-if="countryPriceAttention.show && currentCountryCode === 'IL'", v-show="opened && !loading")
    .flex.justify-between.basket-row
      .txt.text-sm(v-html="countryPriceAttention.text")
mixin generalInfo(cls)
  .basket-duty-info(
    class=cls,
    v-if="!!order.CUSTOM && !['US'].includes(currentCountryCode)",
    v-show="opened && !loading"
  )
    ExclamationAlertIcon.basket-duty-info__icon(color="currentColor", width="24", height="24", topPosition="0")
    .basket-duty-info__text(v-html="order.CUSTOM")

.basketVue.basket.w-full(ref="basket", :class="inplace ? 'basket--inplace' : 'lg1024:sticky'", data-qa="basket-container")
  +usaInfo('lg1024:hidden ontop')
  .basketHolder(:class="{'loading-block': loading }")
    button(
      v-if="!inplace",
      type="button",
      class="basket-mobile-header",
      data-qa="basket-mobile-header-toggle",
      :aria-expanded="mobileOpen",
      aria-controls="basket-mobile-body",
      @click="mobileOpen = !mobileOpen"
    )
      span.basket-mobile-header__title
        | {{ $t('basket_title') }}
        svg.basket-mobile-header__chevron(
          :class="{ 'rotate-180': mobileOpen }",
          width="24",
          height="24",
          viewBox="0 0 24 24",
          fill="none",
          xmlns="http://www.w3.org/2000/svg"
        )
          path(d="M6 9L12 15L18 9", stroke="currentColor", stroke-width="2", stroke-linecap="round", stroke-linejoin="round")
      span.basket-mobile-header__amount(v-if="isFiniteNumber(order.TOTAL_PRICE_WITH_PROMO)") {{ formatMoney(order.TOTAL_PRICE_WITH_PROMO) }}
    div.basket-body(
      :id="inplace ? undefined : 'basket-mobile-body'",
      data-qa="basket-mobile-header-container",
      :class="mobileOpen || inplace ? '' : 'hidden lg1024:block'"
    )
      h3.basket-inplace-title(v-if="inplace") {{ $t('basket_title') }}
      .basket-preview(v-if="hasBasketItems")
        SummaryPreview(
          :items="basketItems",
          :counter-text="summaryCounterText",
          @open="drawerOpen = true"
        )
      .basket-totals
        .basket-rows
          .basket-row
            div {{ $t('basket_order_items') }} ({{ productsCount }})
            span(v-if="isFiniteNumber(itemsPrice)") {{ formatMoney(itemsPrice) }}
          .basket-row(v-if="Number(order.WEIGHT) > 0")
            div {{ $t('basket_order_weight') }}
            span.order-weight {{ order.WEIGHT }} {{ $t('basket_order_weight_item') }}
          .basket-row(v-if="isUseCoralWallet && (canValue > 0)")
            div {{ $t('basket_bonus') }}
            span.order-bonus.basket-row__value--wallet -{{ formatNum(canValue) }}
          .basket-row(v-if="showPoints && isFiniteNumber(order.STANDARD_POINTS)")
            div {{ $t('basket_cashback') }}
            span.order-bonus {{ formatNum(order.STANDARD_POINTS) }}
          .basket-row(v-if="order.TRANSFER_POINTS")
            div {{ $t('BASKET_TRANSFER_POINTS') }}
            span {{ formatNum(order.TRANSFER_POINTS) }}
          .basket-row(v-if="getDeliveryPriceFormatted !== false && $store.state.deliveryTypes.length > 0 && isFiniteNumber(order.DELIVERY_PRICE)")
            div {{ $t('basket_delivery') }}
            span {{ formatMoney(order.DELIVERY_PRICE) }}
          .basket-row(v-if="getCashOnDeliveryPriceFormatted !== false")
            div {{ $t('ORDER_TAX') }}
            span {{ getCashOnDeliveryPriceFormatted }}
          .basket-row(v-if="getTaxPriceFormatted !== false")
            div {{ $t('CHECKOUT_TAX') }}
            span {{ getTaxPriceFormatted }}
          .basket-row(v-if="getDutyPriceFormatted !== false")
            div {{ $t('ddp_title') }}
            span {{ getDutyPriceFormatted }}
          .basket-row(v-if="selectedPickpointInfo")
            div {{ $t('basket_pickpoint') }}
            span
          .basket-row(v-if="promoAllowed && appliedPromoDiscount > 0", data-qa="basket-promo-discount-row")
            div {{ $t('ORDER_PROMO_CODE_TITLE') }}
            span.basket-row__value--positive -{{ formatMoney(appliedPromoDiscount) }}
        .basket-total
          div(v-if="authed || isFriendOrBuyerFromFriend") {{ $t('basket_total') }}
          div(v-else) {{ $t('unauth_total') }}
          span(v-if="isFiniteNumber(order.TOTAL_PRICE_WITH_PROMO)") {{ formatMoney(order.TOTAL_PRICE_WITH_PROMO) }}
        .basket-promo(v-if="promoAllowed")
          SummaryPromoCode(
            :code="appliedPromoDiscount > 0 ? $store.state.promo : promo.code",
            :applied="appliedPromoDiscount > 0",
            :error="promo.error",
            :latin-only-error="latinOnlyError",
            @input="onPromoCodeInput",
            @apply="getPromo(promo.code)",
            @remove="resetPromo"
          )
      .basket-note(v-if="['PL'].includes($store.state.country.code)", v-html="$t('underbasket_pl')")
    .basket-loader(v-show="loading")
      Loader

  +usaInfo('hidden lg1024:block')
  //FreeDelivery(v-if="getDeliveryPriceFormatted !== false && order.DELIVERY_PRICE === 0", :inplace="inplace")
  .sub-busket__unauthed(v-if="!authed && !isFriendOrBuyerFromFriend", v-show="!loading", class="subBasketHolder p-4")
    div(class="flex justify-between items-center basket-row")
      div(class="text-sm flex flex-col")
        span(v-html="$t('unauth_subbasket')")
        a.sub-busket__unauthed_register(href="/registration/?BACK_URL=/checkout_new/", class="text-accentColor cursor-pointer font-medium", analytics-id="analytics-162") {{ $t('unauth_subbasket_reg') }}
      div(class="flex items-end flex-col")
        s(v-if="isFiniteNumber(fullPrice)", class="text-sm") {{ formatMoney(fullPrice) }}
        span(v-if="isFiniteNumber(clubPrice)", class="font-medium") {{ formatMoney(clubPrice) }}
  +ilInfo('hidden lg1024:block')
  +generalInfo('lg1024:block')
  SummaryOrderContentsDrawer(
    :open="drawerOpen",
    :items="basketItems || []",
    :counter-text="summaryCounterText",
    @close="drawerOpen = false"
  )
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import Loader from './Loader.vue'
import FreeDelivery from './basket/FreeDelivery.vue'
import { perfPoint, perfStart, perfEnd } from '@/utils/perfMarks'
import { traceRequest } from '@/utils/sentryTracing'
import SummaryPreview from '@/components/summary/SummaryPreview.vue'
import SummaryOrderContentsDrawer from '@/components/summary/SummaryOrderContentsDrawer.vue'
import SummaryPromoCode from '@/components/summary/SummaryPromoCode.vue'

export default {
  name: 'BasketComponent',
  props: {
    inplace: { type: Boolean, default: false },
  },
  components: {
    Loader,
    FreeDelivery,
    SummaryPreview,
    SummaryOrderContentsDrawer,
    SummaryPromoCode,
  },
  data() {
    return {
      opened: true,
      mobileOpen: false,
      drawerOpen: false,
      promo: {
        code: '',
        isInputShow: false,
        discount: 0,
        type: null,
        error: null,
      },
      latinOnlyError: false,
    }
  },
  computed: {
    ...mapState({
      IS_COUNTRY_GLOBAL: 'IS_COUNTRY_GLOBAL',
      loading: 'loading',
      orderType: 'orderType',
      coralWallet: 'wallet',
      selectedDeliveryType: 'selectedDeliveryType',
      selectedDeliveryTypeService: 'selectedDeliveryTypeService',
      selectedPickpointInfo: 'selectedPickpointInfo',
      currentCountryCode: (state) => state.CUR_LOCATION.ALPHA2,
      promoAllowed: (state) => state.checkoutFields.promo,
      lastOrderParams: 'lastOrderParams',
      serviceState: 'serviceState',
      addressInfo: 'addressInfo',
    }),
    ...mapGetters({
      isUseCoralWallet: 'wallet/isUseCoralWallet',
      order: 'getOrderData',
      isFriendOrBuyerFromFriend: 'isFriendOrBuyerFromFriend',
      basketItems: 'getBasketItems',
    }),
    hasBasketItems() {
      return Array.isArray(this.basketItems) && this.basketItems.length > 0
    },
    itemsPrice() {
      return this.authed ? this.order.PRICE_CLUB : this.order.PRICE_BASE
    },
    showPoints() {
      return this.authed && !this.isFriendOrBuyerFromFriend
    },
    productsCount() {
      const quantity = Number(this.order.QUANTITY)
      if (Number.isFinite(quantity)) return quantity
      if (!Array.isArray(this.basketItems)) return 0
      return this.basketItems.reduce(
        (sum, item) => sum + (Number(item.quantity) || 0),
        0
      )
    },
    summaryCounterText() {
      const count = this.productsCount
      let text =
        count === 1
          ? '1 ' + this.$t('summary_product_single') + '.'
          : this.$t('basket_order_items') + ': ' + count + '.'
      const points = Number(this.order.STANDARD_POINTS)
      if (this.showPoints && Number.isFinite(points)) {
        text +=
          ' ' +
          this.$t('summary_points_label') +
          ': ' +
          this.formatPoints(points) +
          '.'
      }
      return text
    },
    appliedPromoDiscount() {
      return parseFloat(this.$store.state.promoDiscount?.DISCOUNT) || 0
    },
    feeNotifications() {
      return {
        US: { summ: 200, text: 'basket_usa_order_info', global: false },
        IL: { summ: 876, text: 'il_feemodal_more1000', global: true },
      }
    },
    countryPriceAttention() {
      const feeNotifications = this.feeNotifications[this.currentCountryCode]
      if (!feeNotifications) {
        return {
          show: !!this.order.CUSTOM ?? false,
          text: this.order.CUSTOM || '',
        }
      }

      const show =
        this.order.TOTAL_PRICE >= feeNotifications.summ &&
        ((this.IS_COUNTRY_GLOBAL && feeNotifications.global) ||
          (!this.IS_COUNTRY_GLOBAL && !feeNotifications.global))

      return {
        show,
        text: this.$t(feeNotifications.text),
      }
    },
    uid() {
      return window.uid
    },
    promoDiscount() {
      return (
        parseFloat(this.$store.state.promoDiscount.DISCOUNT) /
        (this.order.FULL_PRICE / 100)
      )
    },
    // REFACTOR
    fullPrice() {
      let price = this.authed ? this.order.PRICE_CLUB : this.order.PRICE_BASE
      price +=
        this.getDeliveryPrice !== false ? Number(this.getDeliveryPrice) : 0
      price +=
        this.getCashOnDeliveryPrice !== false
          ? Number(this.getCashOnDeliveryPrice)
          : 0

      if (this.isUseCoralWallet) {
        price -= this.canValue
      }

      price -= parseFloat(this.$store.state.promoDiscount.DISCOUNT)
      price += Number(this.getDutyPrice)
      price += Number(this.getTaxPrice)
      return price
    },
    clubPrice() {
      let price = this.order.PRICE_CLUB
      price +=
        this.getDeliveryPrice !== false ? Number(this.getDeliveryPrice) : 0
      price +=
        this.getCashOnDeliveryPrice !== false
          ? Number(this.getCashOnDeliveryPrice)
          : 0

      if (this.isUseCoralWallet) {
        price -= this.canValue
      }

      price += Number(this.getDutyPrice)
      price += Number(this.getTaxPrice)
      return price
    },
    authed() {
      return this.$store.state.authed
    },
    getDeliveryPrice() {
      let r = 0
      if (!this.selectedDeliveryType || !this.selectedDeliveryType.ITEMS)
        return false
      let item = this.selectedDeliveryType.ITEMS.find(
        (i) => i.ID === this.selectedDeliveryTypeService
      )
      if (item) {
        if (item.PRICE && (item.PRICE === 0 || item.PRICE > 0)) {
          r = item.PRICE
        } else {
          r = false
        }
        if (r === false && this.selectedPickpointInfo) {
          r = this.selectedPickpointInfo.price
        }
      } else {
        if (this.selectedPickpointInfo) {
          r = this.selectedPickpointInfo.price
        } else {
          r = 0
        }
      }
      return r !== false ? Number(r) : false
    },
    getDeliveryPriceFormatted() {
      let r = this.$t('basket_free')
      const price = this.getDeliveryPrice
      if (price !== false) {
        r = this.formatMoney(price)
      }
      return r
    },
    getCashOnDeliveryPrice() {
      return parseFloat(this.order.CASH_ON_DELIVERY) || 0
    },
    getCashOnDeliveryPriceFormatted() {
      let r = false
      const price = this.getCashOnDeliveryPrice
      if (price !== 0) {
        r = this.formatMoney(price)
      }
      return r
    },
    getTaxPrice() {
      return this.order.TAX ?? 0
    },
    getTaxPriceFormatted() {
      let r = false
      const price = this.getTaxPrice
      if (price !== 0) {
        r = this.formatMoney(price)
      }
      return r
    },
    getDutyPrice() {
      return this.order.DUTY ?? 0
    },
    getDutyPriceFormatted() {
      let r = false
      const price = this.getDutyPrice
      if (price !== 0) {
        r = this.formatMoney(price)
      }
      return r
    },
    canValue() {
      return Number(this.coralWallet.BONUS_VALUE) || 0
    },
  },
  watch: {
    loading(isLoading) {
      if (!isLoading && Number(this.order.QUANTITY) > 0) {
        this.$nextTick(() => perfPoint('ui:price-visible'))
      }
    },
    serviceState() {
      if (this.promo.code && this.promo.discount) {
        this.resetPromo()
      }
    },
  },
  async beforeMount() {
    !window.authed &&
      !this.inplace &&
      (await this.$store.dispatch('GET_ORDER_DATA', 0))
  },
  mounted() {
    if (!this.loading && Number(this.order.QUANTITY) > 0) {
      this.$nextTick(() => perfPoint('ui:price-visible'))
    }
  },
  methods: {
    ...mapMutations(['setLoadingStatus', 'UpdatePromo']),
    ...mapMutations({
      setLimitValue: 'wallet/setLimitValue',
    }),
    promoMinus(summ) {
      return summ - (summ / 100) * this.promoDiscount
    },
    getLastOrderParams() {
      const lastOrderParams = this.lastOrderParams?.params ?? {}
      return {
        deliveryId: lastOrderParams.deliveryId ?? null,
        country: lastOrderParams.COUNTRY ?? null,
        city: lastOrderParams.CITY ?? null,
        area: lastOrderParams.AREA ?? null,
      }
    },
    async getOrderData() {
      const params = this.getLastOrderParams()
      await this.$store.dispatch('GET_ORDER_DATA', {
        deliveryId: params.deliveryId,
        paymentId: null,
        positionData: {
          COUNTRY_CODE: params.country,
          CITY_NAME: params.city,
          AREA_NAME: params.area,
        },
        // Передаём профиль, чтобы бек правильно расчитал сумму налога
        profile: { ...this.addressInfo?.PROFILE },
      })
    },
    async getPromo(code) {
      this.setLoadingStatus(true)
      this.promo.error = ''
      const params = this.getLastOrderParams()

      perfStart('promo:apply')

      try {
        await traceRequest('GET /promo', async () => {
          try {
            let {
              data: {
                error,
                result: { DISCOUNT, TYPE },
              },
            } = await this.$axios.get('/promo', {
              params: {
                promo: code,
                deliveryId: params.deliveryId,
                COUNTRY: params.country,
                CITY: params.city,
                AREA: params.area,
                POSTINDEX: this.addressInfo?.PROFILE?.POSTINDEX || null,
              },
            })
            if (!error) {
              this.promo.discount = DISCOUNT
              this.promo.type = TYPE
              this.UpdatePromo({
                result: { DISCOUNT, TYPE },
                promo: this.promo.code,
              })
              await this.getOrderData()
              this.setLimitValue(this.order.CW_VALUE_LIMIT)
            } else {
              this.promo.error = error
            }
          } finally {
            perfEnd('promo:apply')
          }
        })
      } catch (err) {
        console.log('promo error - ', err)
      }
      this.setLoadingStatus(false)
    },
    async resetPromo() {
      this.promo = {
        code: '',
        isInputShow: true,
        discount: 0,
        type: null,
        error: null,
      }
      this.UpdatePromo({
        result: {
          DISCOUNT: this.promo.discount,
          TYPE: this.promo.type,
        },
        promo: this.promo.code,
      })
      await this.getOrderData()
      this.setLimitValue(this.order.CW_VALUE_LIMIT)
    },
    formatMoney(value) {
      return new Intl.NumberFormat(this.$store.state.country.code, {
        style: 'currency',
        currency: this.$store.state.currency,
        currencyDisplay:
          this.$store.state.country.code === 'NO' ? 'code' : 'symbol',
        numberingSystem: 'latn',
      }).format(value)
    },
    formatNum(value) {
      return new Intl.NumberFormat(this.$store.state.country.code, {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: 2,
        numberingSystem: 'latn',
      }).format(value)
    },
    isFiniteNumber(value) {
      return Number.isFinite(Number(value))
    },
    formatPoints(value) {
      if (!Number.isInteger(value)) return this.formatNum(value)
      return new Intl.NumberFormat(this.$store.state.country.code, {
        style: 'decimal',
        useGrouping: true,
        maximumFractionDigits: 0,
        numberingSystem: 'latn',
      }).format(value)
    },
    onPromoCodeInput(event) {
      const defaultValue = event.target.value
      const latinOnlyValue = defaultValue.replace(this.$latinRegex, '')
      event.target.value = latinOnlyValue
      this.promo.code = latinOnlyValue.toUpperCase()
      this.latinOnlyError = defaultValue !== latinOnlyValue
    },
  },
}
</script>
<style scoped lang="scss">
.ilInfo {
  border-radius: var(--st-selectable-borderRadius-size-md, 8px);
  border: 1px solid var(--st-content-border-color-warning-implicit, #f7ceb2) !important;
  background: var(
    --st-content-background-color-warning-subtle,
    #fef7f2
  ) !important;

  b {
    font-size: 1.2em;
  }
}

.basket {
  top: 126px;
  left: 0;

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    gap: 16px;

    > * {
      margin: 0;
    }
  }
}

.freeShip .svg {
  width: 44px;
}

.freeShip .txt {
  width: calc(100% - 44px - 0.75rem);
}

.basketHolder {
  color: #39444c;

  &.loading-block {
    position: relative;

    > *:not(.basket-loader) {
      opacity: 0;
    }
  }

  @media (min-width: 1024px) {
    padding: 23px;
    background: #fff;
    border: 1px solid #e5ecf1;
    border-radius: 16px;
    box-shadow:
      0 2px 8px -1px rgba(4, 8, 13, 0.08),
      0 2px 2px -1px rgba(4, 8, 13, 0.08);
  }
}

.basket-loader {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  @media (min-width: 1024px) {
    border-radius: 15px;
  }
}

.basket-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  height: 52px;
  padding: 12px 16px;
  background: rgba(59, 109, 149, 0.08);
  color: #39444c;
  text-align: left;

  @media (min-width: 1024px) {
    display: none;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: -0.014em;
  }

  &__chevron {
    flex-shrink: 0;
    transition: transform 200ms;
  }

  &__amount {
    white-space: nowrap;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    letter-spacing: -0.014em;
  }
}

.basket-body {
  padding: 0 16px;
  background: rgba(167, 185, 199, 0.04);

  @media (min-width: 1024px) {
    padding: 0;
    background: transparent;
  }
}

.basket--inplace {
  .basket-body {
    padding: 0;
    background: #fff;
  }

  .basket-preview {
    padding-top: 0;
  }

  .basket-promo {
    padding-bottom: 0;
  }

  .basket-duty-info {
    margin: 24px 0 0;
  }
}

.basket-inplace-title {
  margin-bottom: 16px;
  color: #39444c;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}

.basket-preview {
  padding-top: 24px;

  @media (min-width: 1024px) {
    padding-top: 0;
  }
}

.basket-totals {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 12px;
}

.basket-rows {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.basket-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #39444c;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: -0.014em;

  &__value--wallet {
    color: #54941e;
    font-weight: 700;
  }

  &__value--positive {
    color: #54941e;
  }
}

.basket-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #39444c;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  letter-spacing: -0.014em;

  > span {
    white-space: nowrap;
  }
}

.basket-promo {
  padding: 16px 0;

  @media (min-width: 1024px) {
    padding-bottom: 0;
  }
}

.basket-note {
  padding-bottom: 16px;
  color: #39444c;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: -0.014em;

  @media (min-width: 1024px) {
    padding: 12px 0 0;
  }
}

.basket-duty-info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 64px;
  margin: 16px 16px 0;
  padding-left: 20px;
  background: #fef7f2;
  border: 1px solid #f7ceb2;
  border-radius: 12px;

  @media (min-width: 1024px) {
    margin: 0;
  }

  &__icon {
    flex-shrink: 0;
    color: #b86825;
  }

  &__text {
    flex: 1;
    min-width: 0;
    padding: 12px 8px 4px 16px;
    color: #39444c;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: -0.014em;

    :deep(b),
    :deep(strong) {
      display: block;
      margin-bottom: 4px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: -0.014em;
    }

    :deep(a) {
      display: inline-flex;
      align-items: center;
      min-height: 32px;
      color: #534bb4;
      text-decoration: none;
      font-size: 13px;
      line-height: 20px;
      font-weight: 400;
      letter-spacing: -0.014em;
    }
  }
}

.subBasketHolder {
  background: #f8f9f9;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
}

.usaInfo.ontop,
.sub-busket__unauthed {
  @media (max-width: 1023px) {
    margin-left: 16px;
    margin-right: 16px;
  }
}
</style>
